export const ExpandedManagementCardHandler = {
  getExpandedManagementCardObject(context) {
    return context.$store.getters.expandedManagementCardObject;
  },
  getIsCardExpanded(context) {
    return context.$store.getters.isCardExpanded;
  },
  getShouldRefresh(context) {
    return context.$store.getters.shouldRefreshWhenTimerEnds;
  },
  setExpandedManagementCardObject(context, expandedManagementCardObject) {
    context.$store.commit('SET_EXPANDED_MANAGEMENT_CARD_OBJECT', expandedManagementCardObject);
  },
  setIsCardExpanded(context, isCardExpanded) {
    context.$store.commit('SET_IS_CARD_EXPANDED', isCardExpanded);
  },
  setShouldRefreshWhenTimerEnds(context, shouldRefreshWhenTimerEnds) {
    context.$store.commit('SET_SHOULD_REFRESH_WHEN_TIMER_ENDS', shouldRefreshWhenTimerEnds);
  }
};

const state = {
  expandedManagementCardObject: null,
  isCardExpanded: false,
  shouldRefreshWhenTimerEnds: false
};

const getters = {
  expandedManagementCardObject: (state) => {
    return state.expandedManagementCardObject;
  },
  isCardExpanded: (state) => {
    return state.isCardExpanded;
  },
  shouldRefreshWhenTimerEnds: (state) => {
    return state.shouldRefreshWhenTimerEnds;
  }
};

const mutations = {
  SET_EXPANDED_MANAGEMENT_CARD_OBJECT: (state, expandedManagementCardObject) => {
    state.expandedManagementCardObject = expandedManagementCardObject;
  },
  SET_IS_CARD_EXPANDED: (state, isCardExpanded) => {
    state.isCardExpanded = isCardExpanded;
  },
  SET_SHOULD_REFRESH_WHEN_TIMER_ENDS: (state, shouldRefreshWhenTimerEnds) => {
    state.shouldRefreshWhenTimerEnds = shouldRefreshWhenTimerEnds;
  }
};

export default {
  state,
  getters,
  mutations
};
